import './RASingleSliderHandle.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
import { isInternetExplorer, isWindows } from 'utilities/browser';
const classNames = require('classnames');

const RASingleSliderHandle = props => {
    const { value, offset, showTooltip } = props;
    const maxLabelFormatted = formatText('raSingleSlider-maxLabelTooltip');
    const tooltipValue = value == 30 ? maxLabelFormatted : value;
    const msieCondition = isInternetExplorer() && isWindows();
    const tooltipClass = classNames('ra-single-slider-handle__tooltip', { msie: msieCondition });
    const tooltip = showTooltip ? (
        <div className="ra-single-slider-handle__tooltip-container">
            <span className={tooltipClass}>{tooltipValue}%</span>
        </div>
    ) : null;
    const style = {
        left: `${offset}%`,
    };

    return (
        <div className="ra-single-slider-handle__container" style={style}>
            <div className="rc-slider-handle" />
            {tooltip}
        </div>
    );
};

RASingleSliderHandle.propTypes = {
    offset: PropTypes.number.isRequired,
    showTooltip: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
};

RASingleSliderHandle.defaultProps = {
    showTooltip: true,
};

module.exports = RASingleSliderHandle;
